export enum EntityTypes {
	Entity,
	Sub,
	Link,
	System,
	Lookup
}